import { types } from '../actions/types';

const INITIAL_STATE = {
    message: null,
    title: null,
    type: null,
    isVisible: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.SEND_COMPANY_NOTIFICATION:
            const { message, title, type, isVisible } = action.payload
            return {
                ...state, message, title, type, isVisible
            }
        case types.HIDE_COMPANY_NOTIFICATION:
            return{
                ...state, message: null, title: null, type: null, isVisible: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/company-notification-reducer.js